export interface ReleaseNote {
  date: string; // ISO date string
  version?: string; // Optional version number
  title: string;
  description: string;
  features: string[]; // Array of feature highlights
}

export const releaseNotes: ReleaseNote[] = [
  // Newest first
  {
    date: '2026-02-13',
    version: '0.10.0',
    title: 'Family Device Mode & Family Photo',
    description: 'Use a shared tablet in Family mode so everyone can add events and todos as the family. Set a family photo that shows when in Family mode.',
    features: [
      'Family device mode - on tablet or desktop, turn on Family mode so the device acts as the family (events and todos attributed to family, with audit)',
      'Family photo - add or change a family photo in Family Management; it appears in the nav when in Family mode',
      'Exit family mode - one-tap exit in the nav bar when Family mode is on',
      'Family mode only on larger screens - available on tablet and desktop, not on phones'
    ]
  },
  {
    date: '2026-02-13',
    version: '0.9.0',
    title: 'Account Hub & AI Discoveries',
    description: 'Streamlined navigation with your avatar as the gateway to account settings, plus new AI-powered discovery suggestions for events and todos.',
    features: [
      'Avatar navigation - your photo or initials now replaces Family and Settings in the nav (mobile bottom bar and tablet rail)',
      'Account hub at a tap - tap your avatar to reach Family Management, Change Password, What\'s New, and Sign Out',
      'What\'s New moved under Account - find release notes in Settings, cleaner main navigation',
      'AI Discoveries - smart suggestions for events and todos based on your calendar and habits',
      'Removed avatar from top bar - cleaner interface with account access in the nav'
    ]
  },
  {
    date: '2026-01-25',
    version: '0.8.0',
    title: 'Mobile UI Improvements & Enhanced Event Creation',
    description: 'Improved mobile interface with better spacing and a fully-featured event creation experience that matches tablet functionality.',
    features: [
      'Fixed spacing issue between bottom navigation and content on mobile',
      'Added event type selection (Important Date vs Event with Time) to mobile create event',
      'Added advanced settings to mobile create event (priority, recurring, reminders, date type)',
      'Improved recurring event UI with clearer "Occurs every X" dropdown (1-8 options) for both mobile and tablet'
    ]
  },
  {
    date: '2026-01-24',
    version: '0.7.0',
    title: 'Redesigned Mobile Todos Experience',
    description: 'A completely redesigned todos view with swipe gestures, smart filtering, and smooth touch interactions for a better mobile experience.',
    features: [
      'Redesigned todos view with swipe gestures - swipe right to mark done, swipe left to reopen',
      'Smart filtering with status, priority, assignee, and list filters - all in one compact interface',
      'Automatic sorting by priority (critical first) then by date for better organization',
      'Smart defaults - opens with your todos and open status automatically',
      'List management with beautiful tile-based interface',
      'Smooth touch interactions with optimized performance',
      'Fullscreen bottom sheets for better viewing and editing',
      'Create todos directly from the main view with floating action button'
    ]
  },
  {
    date: '2026-01-24',
    version: '0.6.0',
    title: 'Calendar Reliability Improvements',
    description: 'Improved calendar reliability to prevent duplicate events, especially for long-running sessions and recurring events.',
    features: [
      'Fixed duplicate events appearing after long sessions (24+ hours)',
      'Improved recurring event deduplication to prevent duplicate occurrences',
      'Enhanced calendar stability for wall-mounted displays and always-on screens'
    ]
  },
  {
    date: '2026-01-21',
    version: '0.5.0',
    title: 'Toast Notifications & UI Improvements',
    description: 'New toast notification system for better feedback, plus fixes and improvements to the signup flow.',
    features: [
      'New toast notification system with smooth animations for success, error, and loading states',
      'Fixed duplicate recurring events issue',
      'Improved signup verification flow with cleaner, integrated messages'
    ]
  },
  {
    date: '2026-01-20',
    version: '0.4.0',
    title: 'Today View & Calendar Improvements',
    description: 'A new Today view to see everyone\'s day at a glance, plus major improvements to calendar views.',
    features: [
      'New Today view - see all family members\' events and todos in one place with weather',
      'Redesigned all-day events with consistent styling across all views',
      'Improved week view with better event positioning and half-hour markers',
      'Enhanced month view with cleaner date display and optimized layout',
      'Fixed recurring events showing duplicates',
      'Softer, more consistent colors throughout the calendar'
    ]
  },
  {
    date: '2026-01-18',
    version: '0.3.0',
    title: 'Email Verification & Family Invitations',
    description: 'We\'ve made it easier to invite family members and verify your account with email support.',
    features: [
      'Email verification for new accounts - receive and resend verification codes',
      'Invite family members via email with beautiful invitation emails',
      'Resend or cancel pending invitations from the Family page',
      'Improved event styling with peachy colors and consistent design',
      'Enhanced signup flow for smoother account creation'
    ]
  },
  {
    date: '2026-01-11',
    version: '0.2.0',
    title: 'What\'s New - Stay Updated!',
    description: 'We\'ve added a new way to keep you informed about the latest features and improvements.',
    features: [
      'What\'s New page added to navigation (mobile and tablet)',
      'Timeline view of recent releases and features',
      'Easy access to see what\'s changed in the app'
    ]
  },
  {
    date: '2025-12-15',
    version: '0.1.0',
    title: 'Welcome to Runow!',
    description: 'We\'re excited to launch Runow - your family planning companion.',
    features: [
      'Family calendar with shared events',
      'To-do lists with assignments',
      'Weather integration',
      'Mobile and tablet support'
    ]
  },
];
